import { createAction, props } from '@ngrx/store';

import { VatReportsListState } from '../reducers';
import { VatReportStatusEnum } from '../../enums';
import { VatReportEntityModel } from '../../models';

export const LoadVatReportsList = createAction(
  '[VAT report] Load VAT reports List',
  props<{ vatReportListData: VatReportsListState, status: VatReportStatusEnum, page: number }>()
);

export const LoadVatReport = createAction(
  '[VAT report] Load VAT report',
  props<{ vatReport: VatReportEntityModel }>()
);

export const UpdateVatReportUpdatedAt = createAction(
  '[VAT report] Update VAT report updatedAt',
  props<{ updatedAt: Date }>()
);

export const UpdateShouldRefreshEntity = createAction(
  '[VAT report] Update VAT report should refresh flag',
  props<{ isShouldRefresh: boolean }>()
);

export const ClearVatReportUpdatedAt = createAction('[VAT report] Clear VAT report updatedAt');

export const IncrementLoadingRequestsCount = createAction('[VAT report] Increment Loading Requests Count');

export const DecrementLoadingRequestsCount = createAction('[VAT report] Decrement Loading Requests Count');


